// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget-space--wrapper--2FMs0"};